webpackJsonp([2],{

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCRIPT_ON_DEMAND_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadScriptOnDemand; });
var SCRIPT_ON_DEMAND_NAME = 'script-on-demand';
var loadScriptOnDemand = function loadScriptOnDemand($el) {
  var src = $el.data('src');
  if (!src) {
    console.error('A \'data-src\' is required for a lazy script-on-demand');
    return;
  }
  var scriptAttrs = $el.data('scriptAttrs') || {};
  var script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.async = true;
  Object.keys(scriptAttrs).map(function (attrName) {
    script.dataset[attrName] = scriptAttrs[attrName];
  });
  $el[0].appendChild(script);
  $el.removeAttr('data-src').removeAttr('data-script-attrs');
};

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mustache__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vendor_typeahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styleguide_src_assets_modules_keyboard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_abtest_smart_filters__ = __webpack_require__(342);






function initSearch() {
  var $desktopSearch = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search");
  var $tabletSearchTray = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search-tray");
  var $searchWrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search__wrap");
  var $searchOverlay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search-tray__overlay");
  var $searchIconButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tablet-site-search__icon");
  var $searchForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-form-search");
  var $searchInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-site-search__textbox");
  var $clearSearchBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-form-search__x");
  var $closeButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-search__close");
  var $noResultSearchCTA = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#nRS");
  var $noResultSearchWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#nRSM");
  var $noResultSearchInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#nRSC");
  var formSearchFull = 'form-search--full';
  var searchAppended = false;
  var searchActive = false;
  $clearSearchBtn.on('click', resetSearch);
  $searchInput.on('input', initControls);
  function showFormControls() {
    $searchForm.addClass(formSearchFull);
  }
  function hideFormControls() {
    $searchForm.removeClass(formSearchFull);
  }
  function resetSearch() {
    $searchInput.focus();
    hideFormControls();
  }
  function initControls(e) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).val().length > 0) {
      showFormControls();
    } else {
      hideFormControls();
    }
  }
  function noResultsSearchTabletHide() {
    $noResultSearchWrapper.hide();
    $noResultSearchInput.show();
  }
  function hideSearch() {
    $tabletSearchTray.slideUp("600", "easeInOutExpo");
    $searchOverlay.fadeOut("800", function () {
      searchActive = false;
    });
  }
  function trayToggle() {
    $searchInput.val('');
    if (searchActive) {
      $tabletSearchTray.slideUp("600", "easeInOutExpo");
      $searchOverlay.fadeOut("800", function () {
        searchActive = false;
      });
      hideFormControls();
    } else {
      $searchOverlay.fadeIn("800");
      $tabletSearchTray.slideDown("600", "easeInOutExpo");
      $searchInput.focus();
      searchActive = true;
    }
  }
  function appendDesktopSearch() {
    if (searchAppended) {
      noResultsSearchTabletHide();
      $searchWrap.appendTo($desktopSearch);
      $searchIconButton.off("click", trayToggle);
      $noResultSearchCTA.off("click", trayToggle);
      $searchOverlay.off("click", hideSearch);
      hideSearch();
      hideFormControls();
      searchAppended = false;
    }
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    appendDesktopSearch();
  });
}

/*
* search.js
*/

function initSearchSuggestions() {
  /*
  Suggestive Search
  =================
  */

  var searchDep = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-site-search__textbox").data("dep");
  var rcProps = __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(window, 'rcProps.search', {}); //see constants in /r/scripts.jsp

  // Products
  var productsBH = new __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default.a({
    datumTokenizer: __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default.a.tokenizers.obj.whitespace("productName"),
    queryTokenizer: __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default.a.tokenizers.whitespace,
    remote: {
      url: '/r/ajax/VisualSearch.jsp?q=%QUERY&d=' + searchDep,
      wildcard: '%QUERY'
    }
  });

  // Text Suggestions
  var textSuggestionsBH = new __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default.a({
    datumTokenizer: __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default.a.tokenizers.obj.whitespace("searchTerm"),
    queryTokenizer: __WEBPACK_IMPORTED_MODULE_2_vendor_typeahead___default.a.tokenizers.whitespace,
    remote: {
      url: '/r/ajax/TextSuggestions.jsp?q=%QUERY&d=' + searchDep,
      wildcard: '%QUERY'
    }
  });
  var displaySuggestionsForNoInput = rcProps.displaySuggestionsForNoInput;

  // Divert Tab into the suggestions panel only while it is actually open and
  // visible. When it is closed, do nothing so native Tab moves focus to the
  // next control (the submit icon). Hijacking Tab unconditionally and then
  // focusing a hidden results container is a no-op, which trapped keyboard
  // focus in the search field.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox').on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode !== 9 || e.shiftKey) return;
    var $siteSearchResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results');
    if ($siteSearchResults.is(':visible')) {
      e.preventDefault();
      $siteSearchResults.attr('tabindex', '0').focus();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox#js-no-results-target').on("keydown", function (e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode == 9 && !e.shiftKey) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.search-results__cta').focus();
    }
  });

  //AB Test 854 - Smart Filters Logic
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox:not(.ab854__search__textbox)').typeahead({
    hint: false,
    highlight: true,
    autoselect: false,
    minLength: 0,
    classNames: {
      menu: 'site-search__results',
      highlight: 'site-search__highlight'
    }
  }, {
    name: 'textSuggestions',
    display: function display(obj) {
      return obj.suggestion;
    },
    source: textSuggestionsBH,
    templates: {
      header: function header() {
        return rcProps.textSuggestionHeader;
      },
      suggestion: function suggestion(data) {
        var gender = (data.gender || '').toLowerCase();
        return __WEBPACK_IMPORTED_MODULE_1_mustache___default.a.render(rcProps.textSuggestionTemplate, {
          href: data.suggestionUrl,
          suggestion: data.suggestion,
          isBrand: data.termType === "Brand" || data.termType === 'Brand Category',
          isWomens: gender === 'womens',
          isMens: gender === 'mens',
          isKids: gender === 'kids'
        });
      }
    },
    limit: rcProps.textSuggestionLimit
  }, {
    name: 'recent',
    display: function display(obj) {
      return obj.searchText;
    },
    source: function source(query, callback) {
      callback(JSON.parse(rcProps.recentSearchJson));
    },
    templates: {
      header: function header() {
        return rcProps.recentSearchHeader;
      },
      suggestion: function suggestion(data) {
        return __WEBPACK_IMPORTED_MODULE_1_mustache___default.a.render(rcProps.recentSearchTemplate, data);
      }
    },
    limit: rcProps.recentSearchLimit
  }, {
    name: 'products',
    display: 'productName',
    source: productsBH,
    templates: {
      header: function header(data) {
        if (data && data.query && data.query.length >= rcProps.minLengthBeforeSearching) {
          return rcProps.relatedProductsHeader;
        } else {
          return rcProps.recentlyViewedHeader;
        }
      },
      suggestion: function suggestion(data) {
        /* backticks for multiline literal, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals */
        return __WEBPACK_IMPORTED_MODULE_1_mustache___default.a.render(rcProps.productSuggestionTemplate, data);
      }
    },
    limit: rcProps.productSuggestionLimit // TODO GRAP-10426: set limit to 12
  }).on('click', function () {
    if (typeof logEngagement === 'function') {
      logEngagement(window.location.href, 'Search Box', 'Click');
    }
  });

  // Stacked Search Suggestion Layout
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dropdown-menu").addClass("site-search__predictions").css({
    "left": "",
    "z-index": "",
    "right": ""
  });

  // Update: Ensure results container is focusable
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox').on('typeahead:render', function (e) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__suggestions .tt-suggestion ').length) {
      wrapSuggestionsHandler();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-aria-search-result').text(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results .tt-suggestion ').length + rcProps.ariaText);
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-aria-search-result').text(rcProps.noResultsText);
    }
    wrapHorizontalResults();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').on('focus', function (e) {
    // add tt-open class from typeahead.js and add tabindex for tabbing
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).show().addClass('tt-open').attr('tabindex', '0');
  });

  // Close Results and focus on Submit Icon when tabbing past last item
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__results').on('focusout', function (evt) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $focusable = __WEBPACK_IMPORTED_MODULE_3__styleguide_src_assets_modules_keyboard__["a" /* default */].findFocusable($el);
    var $firstFocusable = $focusable.eq(0);
    var $lastFocusable = $focusable.eq(-1);
    var isFirstItem = evt.target === $firstFocusable[0];
    var isLastItem = evt.target === $lastFocusable[0];
    var isTab = __WEBPACK_IMPORTED_MODULE_3__styleguide_src_assets_modules_keyboard__["a" /* default */].parseKey(evt) === 'TAB';
    if (isLastItem) {
      // Keyboard.releaseFocus($el);
      $el.hide().removeClass('tt-open trapped').removeAttr('tabindex');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__submit').focus();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox').on('typeahead:cursorchange', function (ev, suggestion) {
    var index;
    if (suggestion && 'index' in suggestion) index = suggestion.index;else index = -1;
    var text = "";
    if (!suggestion) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-aria-search-result').text(text);
    } else {
      //Search results are only two type, if not Product, we put them all to SUGGESTION type.
      if (suggestion.termType == 'Product') {
        if (index == 0) text = "Related Products" + " " + suggestion.brand + " " + suggestion.productName + " " + suggestion.price;else text = suggestion.brand + " " + suggestion.productName + " " + suggestion.price;
      } else {
        if (index == 0) text = "Suggestions" + " " + suggestion.suggestion;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-aria-search-result').text(text);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".twitter-typeahead").addClass("site-search__typeahead").css({
    display: "block"
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dataset-textSuggestions").addClass("site-search__suggestions");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dataset-recent").addClass("js-recent-searches");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tt-dataset-products").addClass("predict-related");
}
function wrapHorizontalResults() {
  var $suggestionCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-suggestion-horizontal');
  if ($suggestionCarousel && $suggestionCarousel.parent().hasClass('product')) return;
  $suggestionCarousel.wrap('<div class="product grid__col"></div>');
  var $suggestionItemWrap = $suggestionCarousel.parent();
  $suggestionItemWrap.wrapAll('<div class="grid n-block-grid--3 u-margin-t--lg u-padding-b--sm site-search__placeholder"></div>');
}
function wrapSuggestions($el) {
  if ($el && $el.parent().hasClass('ui-list__item')) return;
  $el.wrap('<li class="ui-list__item js-search-suggestion-item-wrap"></li>');
  var $suggestionItemWrap = $el.parent();
  $suggestionItemWrap.wrapAll('<ul class="ui-list"></ul>');
}
function wrapSuggestionsHandler() {
  var $suggestionItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-suggestion-item');
  var $simpleSuggestionItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-simple-suggestion-item');
  wrapSuggestions($suggestionItem);
  wrapSuggestions($simpleSuggestionItem);
}
/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-search__textbox').length) {
    return;
  }
  function handleScreenWidth() {
    if (window.innerWidth <= 1001) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-header--pill').length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__submit').addClass('u-margin-t--xs');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__textbox').addClass('u-padding-tb--md');
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__textbox').removeClass('u-padding-tb--md');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-search__submit').removeClass('u-margin-t--xs');
      }
    } else {}
  }
  handleScreenWidth();
  window.addEventListener('resize', function () {
    handleScreenWidth();
  });
  initSearch();
  initSearchSuggestions();
});

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(3);
// Import necessary dependencies




// Define plugin name and default options
var PLUGIN_NAME = 'stateSearch';
var DEFAULTS = {
  shippingZipCode: ""
};

// List of states and their respective zip codes (for demonstration purposes)
var states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California, 90703', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

/**
 * Extracts the zip code from a given suggestion string.
 * @param {string} suggestion - The selected state and zip code suggestion.
 * @returns {string} - Extracted zip code value.
 */
var getZipCodeValue = function getZipCodeValue(suggestion) {
  var values = suggestion.split(",");
  var lastValue = values[values.length - 1].trim(); // Get and trim the last element
  return lastValue;
};

/**
 * Fills the zip code input field based on the selected suggestion.
 * @param {string} suggestion - The selected state and zip code suggestion.
 * @param {Object} opts - Options object containing the zip code input field ID.
 */
var fillZipCode = function fillZipCode(suggestion, opts) {
  var zipCodeInput = opts.zipCodeInput;
  var $shippingZipCodeInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(zipCodeInput));
  var zipCode = getZipCodeValue(suggestion);
  $shippingZipCodeInput.val(zipCode);
};

/**
 * Creates a substring matcher for the typeahead functionality.
 * @param {Array<string>} strs - List of strings to match against.
 * @returns {function} - A function that returns matches for a given query.
 */
var substringMatcher = function substringMatcher(strs) {
  return function findMatches(query, callback) {
    var matches = [];
    var substrRegex = new RegExp(query, 'i'); // Case-insensitive regex for matching

    // Find all strings containing the query
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(strs, function (i, str) {
      if (substrRegex.test(str)) {
        matches.push(str);
      }
    });
    callback(matches); // Return matches via the callback
  };
};

/**
 * Initializes the typeahead functionality on a given element.
 * @param {jQuery} $el - The jQuery-wrapped element to initialize the typeahead on.
 * @param {Object} opts - Options object containing configurations.
 */
var initializeTypeahead = function initializeTypeahead($el, opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-state-search-container .js-state-search").typeahead({
    hint: true,
    highlight: true,
    minLength: 1
  }, {
    name: 'states',
    source: substringMatcher(states)
  });

  // Bind the select event to populate the zip code field
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-state-search').on('typeahead:select', function (ev, suggestion) {
    fillZipCode(suggestion, opts);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-state-search').on('typeahead:autocomplete', function (ev, suggestion) {
    fillZipCode(suggestion, opts);
  });
};

/**
 * Main function to initialize the state search plugin.
 * @param {HTMLElement} el - The container element for the plugin.
 * @param {Object} options - Configuration options for the plugin.
 */
function stateSearch(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el); // Convert the element to a jQuery object
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el); // Merge default and provided options
  initializeTypeahead($el, opts); // Initialize the typeahead functionality
}

// Register the plugin with jQuery
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stateSearch);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_lazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_lazy_script_on_demand__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_search__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_state_search__ = __webpack_require__(310);





var initLazy = function initLazy() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Lazy(__WEBPACK_IMPORTED_MODULE_2_modules_lazy_script_on_demand__["a" /* SCRIPT_ON_DEMAND_NAME */], __WEBPACK_IMPORTED_MODULE_2_modules_lazy_script_on_demand__["b" /* loadScriptOnDemand */]);
  var lazyObjDefault = {
    effect: 'fadeIn',
    effectTime: 500,
    threshold: 0
  };
  var lazyObjHPGramOptions = {
    beforeLoad: function beforeLoad(element) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).attr('id') === 'likeshop-carousel') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-gram-preload-skeleton').hide();
      }
    }
  };
  var lazyObjGram = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(lazyObjDefault, lazyObjHPGramOptions);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy(lazyObjDefault);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-gram-lazy').lazy(lazyObjGram);
};
initLazy();
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_search__["a" /* default */])();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-state-search').stateSearch();
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applied_filters_store__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_log_engagement__ = __webpack_require__(64);


$(document).on('click', '.js-clear-search', function (e) {
  e.preventDefault();
  var $input = $('.ab854__search__textbox');
  $input.val('').trigger('input').focus();
  updateClearSearchVisibility();
});
$(function () {
  bindResetButton($('.generated__questions'));
  var $originalSearchTerm = $('#original-search-term');
  if ($originalSearchTerm.length) {
    var correctedSearchTerm = $('#smart_search_term').val();
    var originalSearchTerm = $originalSearchTerm.text();
    window.history.replaceState(null, document.title, window.location.href.replace('search=' + encodeURIComponent(originalSearchTerm), 'search=' + correctedSearchTerm));
  }
  $('.js-smart-filters').on('click', function (e) {
    $.modal({
      open: 'smart-filters',
      type: 'custom',
      triggerOpen: true,
      triggerElement: $(this),
      onClose: function onClose() {
        var $form = $('#smart-filters-form');
        var fieldsetId = $form.data('fieldsetId');
        if (fieldsetId) {
          var $fieldset = $("#".concat(fieldsetId));
          var originalIndex = $fieldset.data('index');
          if (originalIndex) {
            $('fieldset', $form).eq(originalIndex - 1).after($fieldset);
          }
        }
        $form.data('fieldsetId', '');
      }
    });
    if (e && e.originalEvent) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__global_log_engagement__["a" /* logEngagement */])(window.location.href, 'smart_filter_pill_more', 'click');
    }
  });
  $('.js-smart-filter-question').on('click', function () {
    var $this = $(this);
    var fieldsetId = $this.data('fieldsetId');
    $('#smart-filters-form').data('fieldsetId', fieldsetId).prepend($("#".concat(fieldsetId)));
    $('.js-smart-filters').trigger('click');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__global_log_engagement__["b" /* logEngagementWithDetails */])(window.location.href, 'smart_filter_pill', 'click', $this.data('category'));
  });
});
function generatePills() {
  var $questionContainer = $('.generated__questions');
  var checkedInputs = $questionContainer.find('input[type="checkbox"]:checked');
  var $pillContainer = $('#selected-filters');
  var $filteredText = $('#filtered-text');
  var $filtersContainer = $('.filters-container');
  $pillContainer.html('');
  var $ul = $('<ul>');
  $ul.addClass('horizontal-scroll__item-wrap u-margin-b--none');
  checkedInputs.each(function () {
    $ul.append(generatePillListItem($(this), $questionContainer, $filteredText));
  });
  if (checkedInputs.length > 0) {
    var $clearBtn = $('.clear-btn', $filtersContainer);
    if (!$clearBtn.length) {
      $clearBtn = $('<button>');
      $clearBtn.addClass('clear-btn pill-button pill-button--black u-white-space--nowrap u-margin-l--lg');
      $clearBtn.text('Clear Filters');
      $clearBtn.on('click', function () {
        $('input[type="checkbox"]', $questionContainer).prop('checked', false);
        $pillContainer.html('');
        $filteredText.addClass('u-hide');
        $clearBtn.remove();
        $('#submit-smart-filters').trigger('click');
      });
      $filteredText.removeClass('u-hide');
      $($filtersContainer).append($clearBtn);
    }
  } else {
    $('#filtered-text').addClass('u-hide');
    $('.clear-btn').remove();
  }
  $pillContainer.append($ul);
  setTimeout(function () {
    var $scrollEl = $('.js-horizontal-scroll');
    if ($scrollEl.length && typeof $scrollEl.horizontalScroll === 'function') {
      $scrollEl.horizontalScroll();
    }
  }, 0);
  $('.js-modal-close').trigger('mousedown');
  $('.js-clear-search').show();
}
function generatePillListItem($input, $questionContainer, $filteredText) {
  var inputId = $input.attr('id');
  var label = $questionContainer.find("label[for=\"".concat(inputId, "\"] .push-button__copy")).text().trim();
  if (!label) return;
  var $li = $('<li class="horizontal-scroll__item horizontal-scroll__item--basis-none">');
  var $pill = $("<div class=\"pill-button pill-button--light-grey\" data-input-id=\"".concat(inputId, "\">"));
  var $span = $('<span>');
  $span.text(label);
  $pill.append($span);
  var $closeBtn = $('<button type="button" class="u-margin-l--xs">');
  $closeBtn.html("\n        <span class=\"icon icon--x\">\n          <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n            <path d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\"></path>\n          </svg>\n        </span>");
  $closeBtn.on('click', function () {
    $input.prop('checked', false);
    var $ul = $li.closest('ul');
    $li.remove();
    if (!$ul.children().length) {
      $('.clear-btn').remove();
      $filteredText.addClass('u-hide');
      $('#reset-smart-filters').trigger('click');
    } else {
      $input.trigger('change');
      $('#submit-smart-filters').trigger('click');
    }
  });
  $pill.append($closeBtn);
  $li.append($pill);
  return $li;
}

// NEW: UX-19852
var smartFiltersQuestionId = null;
$(document).on('click', '.smart-filters-mock', function () {
  $.modal({
    url: 'smartFiltersModal.html',
    type: 'custom',
    triggerOpen: true,
    triggerElement: $(this),
    onComplete: initSmartFiltersModalMain
  });
});

// NEW: UX-19852
$(document).on('click', '.js-smart-filter-question-mock', function () {
  smartFiltersQuestionId = $(this).data('question-id') || null;
  $.modal({
    url: 'smartFiltersModal.html',
    type: 'custom',
    triggerOpen: true,
    triggerElement: $(this),
    // the pill is the opener for focus/ARIA purposes
    onComplete: initSmartFiltersModalMain
  });
});
function getSearchScope(el) {
  var $modal = $(el).closest('.modal');
  return $modal.length ? $modal : $(document);
}
function updateClearSearchVisibility($scope) {
  var $input = $scope.find('.ab854__search__textbox').first();
  var $clear = $scope.find('.js-clear-search').first();
  if (!$input.length || !$clear.length) return;
  var hasText = $.trim($input.val()).length > 0;
  var isFocused = $input.is(':focus');

  // your requirement: show only when focused + has text
  $clear.toggle(hasText && isFocused);
}

// bind for both modal + page inputs
$(document).off('input.ab854 focus.ab854 blur.ab854', '.ab854__search__textbox').on('input.ab854', '.ab854__search__textbox', function () {
  updateClearSearchVisibility(getSearchScope(this));
}).on('focus.ab854', '.ab854__search__textbox', function () {
  updateClearSearchVisibility(getSearchScope(this));
}).on('blur.ab854', '.ab854__search__textbox', function () {
  var $scope = getSearchScope(this);
  setTimeout(function () {
    return updateClearSearchVisibility($scope);
  }, 0);
});

// clear button: clears textbox in same scope (modal clears modal input, page clears page input)
$(document).off('pointerdown.ab854 mousedown.ab854', '.js-clear-search').on('pointerdown.ab854', '.js-clear-search', function (e) {
  e.preventDefault();
  var $scope = getSearchScope(this);
  var $input = $scope.find('.ab854__search__textbox').first();
  if (!$input.length) return;
  $input.val('').trigger('input').focus();
  updateClearSearchVisibility($scope);
});

// NEW: UX-19852
function reorderSmartFilterQuestions($questionContainer, questionId) {
  if (!questionId) return;

  // Find the fieldset with the matching data-question-id
  var $target = $questionContainer.find('fieldset[data-question-id="' + questionId + '"]').first();
  if (!$target.length) return;

  // Move it to the top
  $target.prependTo($questionContainer);
}
function initSmartFiltersModalMain() {
  $.ajax({
    url: 'smartFilterModalQuestions.html',
    success: function success(response) {
      var $questionContainer = $('.generated__questions');
      $questionContainer.empty().append(response);
      $('.loading').hide();
      if (smartFiltersQuestionId) {
        reorderSmartFilterQuestions($questionContainer, smartFiltersQuestionId);
        smartFiltersQuestionId = null;
      }

      // Bind store sync (modal -> store)
      bindModalFilterStoreSync($questionContainer);

      // Sync modal UI from store (store -> modal)
      syncModalFromStore($questionContainer);

      // Submit just closes
      bindSubmitHandler();

      // Reset clears store + closes
      bindResetButton($questionContainer);
    }
  });
  updateClearSearchVisibility($('.modal'));
}
function syncModalFromStore($questionContainer) {
  var selectedIds = new Set(__WEBPACK_IMPORTED_MODULE_0__applied_filters_store__["a" /* default */].getAll().filter(function (f) {
    return f.source === 'smartModal';
  }).map(function (f) {
    return f.id;
  }).filter(Boolean));
  $questionContainer.find('input[type="checkbox"]').each(function () {
    var $input = $(this);
    var id = $input.data('smart-id') || $input.attr('id');
    if (!id) return;
    $input.prop('checked', selectedIds.has(id));
  });
}
function toModalFilter($input, $questionContainer) {
  var id = $input.data('smart-id') || $input.attr('id') || null;

  // Find label text reliably (works even when input is not nested in label)
  var label = '';
  if (id) {
    label = $questionContainer.find("label[for=\"".concat(CSS.escape(id), "\"] .push-button__copy")).first().text().trim();
  }

  // Fallbacks (in case markup varies)
  if (!label) {
    label = $input.closest('fieldset').find('.push-button__copy').first().text().trim();
  }
  return {
    type: 'smart',
    source: 'smartModal',
    id: id,
    // IMPORTANT: should be stable (prefer data-smart-id if possible)
    name: $input.data('question-id') || null,
    value: $input.val() || $input.data('value') || null,
    label: label
  };
}
function bindModalFilterStoreSync($questionContainer) {
  $questionContainer.off('change.smartModalStore', 'input[type="checkbox"]').on('change.smartModalStore', 'input[type="checkbox"]', function () {
    var $input = $(this);
    var f = toModalFilter($input, $questionContainer);

    // If we can't identify or label it, don't write garbage into store
    if (!f.id || !f.label) return;
    if ($input.prop('checked')) __WEBPACK_IMPORTED_MODULE_0__applied_filters_store__["a" /* default */].upsert(f);else __WEBPACK_IMPORTED_MODULE_0__applied_filters_store__["a" /* default */].remove(f);
  });
}
function bindSubmitHandler() {
  $(document).off('click.smartFiltersSubmit', '.submit-questions').on('click.smartFiltersSubmit', '.submit-questions', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // No pill building here. Pills render from store.
    $('.js-modal-close').trigger('mousedown');
    updateClearSearchVisibility();
  });
}
function bindResetButton($container) {
  $(document).off('click.smartFiltersReset', '#reset-smart-filters').on('click.smartFiltersReset', '#reset-smart-filters', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Uncheck modal UI (optional; store.clear() will also cause a rerender)
    $container.find('input[type="checkbox"]').prop('checked', false);

    // Clear unified state (this drives page pills)
    __WEBPACK_IMPORTED_MODULE_0__applied_filters_store__["a" /* default */].clear();

    // Clear search UI bits if needed
    $('.ab854__search__textbox').val('');
    updateClearSearchVisibility($('.modal'));
    $('.js-modal-close').trigger('mousedown');
  });
}

// Mock Content End

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

module.exports = Mustache;

/***/ })

},[322]);


// WEBPACK FOOTER //
// dist/deferred-chrome.js